import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '@/shared/utils/formatting';

const headingVariants = cva('text-text-primary leading-tight', {
  variants: {
    size: {
      hero: 'text-4xl md:text-5xl font-bold tracking-tight',
      page: 'text-2xl md:text-3xl font-bold tracking-tight',
      section: 'text-lg md:text-xl font-semibold',
      card: 'text-base font-semibold leading-snug',
      label: 'text-sm font-semibold',
    },
  },
  defaultVariants: {
    size: 'page',
  },
});

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

type HeadingProps = Omit<React.ComponentProps<'h1'>, 'ref'> &
  VariantProps<typeof headingVariants> & {
    level?: HeadingLevel;
  };

function Heading({ className, size, level = 2, ...props }: HeadingProps) {
  const Tag = `h${level}` as const;

  return (
    <Tag data-slot="heading" className={cn(headingVariants({ size, className }))} {...props} />
  );
}

export { Heading, headingVariants, type HeadingProps };
